import React, { useState, useEffect } from "react"
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from "draftjs-to-html"
import EditorWrap from "./style.js"
import { validateInput } from "../../../Utilities/validator.js"
import { renderToString } from "react-dom/server"

export const WysiwygEditor = ({
  value,
  onChange,
  changed,
  hideToolbar = false,
  resetEditorState,
  setEditorState,
  editorRef,
  formAr,
  index,
  setFormAr,
  handleReturn,
  validators,
  getTemplate
}) => {
  let editorState = EditorState.createWithContent(
    ContentState.createFromBlockArray(convertFromHTML(value))
  )

  let defaultValue = renderToString(getTemplate)

  // let editorState = useMemo(() => {
  //   const contentState = value
  //     ? ContentState.createFromBlockArray(convertFromHTML(value))
  //     : ContentState.createFromText(defaultValue)
  //   return EditorState.createWithContent(contentState)
  // }, [resetEditorState, value])

  const [description, setDescription] = useState(editorState)

  useEffect(() => {
    if (
      draftToHtml(convertToRaw(editorState.getCurrentContent())) !==
      draftToHtml(convertToRaw(description.getCurrentContent()))
    )
      setDescription(editorState)
  }, [changed])

  useEffect(() => {
    if (resetEditorState === true) {
      let emptyEditorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(defaultValue))
      )
      setDescription(emptyEditorState)
      setEditorState(false)
    }
    if (resetEditorState === false) {
      let emptyEditorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(defaultValue))
      )
      setDescription(emptyEditorState)
      setEditorState(false)
    }
  }, [resetEditorState, defaultValue])

  const validateField = (e) => {
    if (formAr) {
      const result = validateInput(validators, e)
      formAr[index].error = result
      if (e.preventDefault) e.preventDefault()
      formAr[index].errormsg = result
      setFormAr(formAr)
    }
  }

  handleReturn = (e, des) => {
    if (e.keyCode === 13) {
      e.preventDefault()
    }
  }

  // Custom paste handler to clean up formatting from external sources
  const handlePasteText = (text, html, editorState) => {
    if (html) {
      // Clean up HTML from Word, Excel, etc.
      let cleanedHtml = html
        .replace(/<o:p[^>]*>/g, '')
        .replace(/<\/o:p>/g, '')
        .replace(/<w:[^>]*>/g, '') 
        .replace(/<\/w:[^>]*>/g, '')
        .replace(/<m:[^>]*>/g, '') 
        .replace(/<\/m:[^>]*>/g, '')
        .replace(/<v:[^>]*>/g, '')
        .replace(/<\/v:[^>]*>/g, '')
        .replace(/<st1:[^>]*>/g, '') 
        .replace(/<\/st1:[^>]*>/g, '')
        .replace(/<xml[^>]*>/g, '')
        .replace(/<\/xml>/g, '')
        .replace(/<meta[^>]*>/g, '') 
        .replace(/<link[^>]*>/g, '') 
        .replace(/<style[^>]*>[\s\S]*?<\/style>/g, '') 
        .replace(/<script[^>]*>[\s\S]*?<\/script>/g, '')
        .replace(/<head[^>]*>[\s\S]*?<\/head>/g, '')
        .replace(/<body[^>]*>/g, '') 
        .replace(/<\/body>/g, '') 
        .replace(/<html[^>]*>/g, '') 
        .replace(/<\/html>/g, '') 
        .replace(/<div[^>]*>/g, '<p>')
        .replace(/<\/div>/g, '</p>')
        .replace(/<p[^>]*>\s*<\/p>/g, '') 
        .replace(/<p[^>]*>\s*<br\s*\/?>\s*<\/p>/g, '') 
        .replace(/<br\s*\/?>\s*<br\s*\/?>/g, '</p><p>')
        .replace(/^\s*<p[^>]*>/g, '') 
        .replace(/<\/p>\s*$/g, '') 
        .replace(/\n\s*\n/g, '</p><p>')
        .replace(/\n/g, '<br>') 
        .replace(/\s+/g, ' ') 
        .replace(/\u00A0/g, ' ')
        .replace(/\u200B/g, '') 
        .replace(/\u200C/g, '') 
        .replace(/\u200D/g, '') 
        .replace(/\uFEFF/g, '') 
        .trim()

      if (cleanedHtml && cleanedHtml !== '<p></p>') {
        return cleanedHtml
      }
    }

    if (text) {
      let cleanedText = text
        .replace(/\r\n/g, '\n') 
        .replace(/\r/g, '\n')
        .replace(/\n\s*\n/g, '\n\n')
        .replace(/\n{3,}/g, '\n\n') 
        .replace(/\s+/g, ' ') 
        .replace(/\u00A0/g, ' ')
        .replace(/\u200B/g, '') 
        .replace(/\u200C/g, '') 
        .replace(/\u200D/g, '') 
        .replace(/\uFEFF/g, '') 
        .trim()

      return cleanedText
    }

    return text
  }

  return (
    <EditorWrap>
      <Editor
        handleReturn={handleReturn}
        // handleReturn={(e) =>
        //   handleReturn(e, draftToHtml(convertToRaw(description.getCurrentContent())))
        // }
        ref={editorRef}
        editorState={description}
        toolbarClassName='toolbarClassName'
        wrapperClassName='wrapperClassName'
        editorClassName='editorClassName'
        onEditorStateChange={(editorState) => setDescription(editorState)}
        onChange={(e) => {
          validateField(draftToHtml(convertToRaw(description.getCurrentContent())))
          onChange(draftToHtml(convertToRaw(description.getCurrentContent())))
        }}
        // toolbarOnFocus={true}
        toolbarHidden={hideToolbar}
        handlePastedText={handlePasteText}
        toolbar={{
          fontFamily: {
            options: ["Arial", "Georgia", "Impact", "Tahoma", "Verdana"]
          },
          options: ["fontFamily", "inline", "blockType", "link", "list", "emoji"],
          inline: {
            options: ["bold", "italic", "underline", "superscript", "subscript"]
          },
          list: { inDropdown: true },
          image: {
            // uploadCallback: uploadImageCallBack,
            alt: { present: false, mandatory: false }
          }
        }}
      />
    </EditorWrap>
  )
}